
export default function Footer() {
  const companyInfo = {
    name: '株式会社理想の住まい',
    address: '〒123-4567 東京都港区青山1-2-3 青山ビル5F',
    phone: '03-1234-5678',
    license: '国土交通大臣(1)第12345号',
    hours: '平日 9:00-18:00 / 土日祝 9:00-17:00'
  };

  const quickLinks = [
    { name: 'ホーム', href: '/' },
    { name: '物件検索', href: '/search' },
    { name: 'サービス', href: '/service' },
    { name: '会社案内', href: '/company' },
    { name: 'プライバシーポリシー', href: '/privacy' },
    { name: 'サイトマップ', href: '/sitemap' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              logo
            </h3>
            <p className="text-gray-300 mb-4">
              地域密着型の不動産会社として、お客様一人ひとりのライフスタイルに合った最適な物件をご提案します。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-blue-400 rounded-full hover:bg-blue-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-pink-600 rounded-full hover:bg-pink-700 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-sm"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">会社情報</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p>{companyInfo.name}</p>
              <p>{companyInfo.address}</p>
              <p>TEL: {companyInfo.phone}</p>
              <p>免許番号: {companyInfo.license}</p>
              <p>営業時間: {companyInfo.hours}</p>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">クイックリンク</h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © 2024 株式会社理想の住まい. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Made with Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
